/*
  File: Login.css
  Author: Binish Mookken
  Date: April-June 2024

  Description:

*/

import { useState } from "react";
import logo from "./images/logo.png";
import "./Landing.css";
import LoginPage from "./Login";

const Landing = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        height: "calc(93vh - 90px)",
        flexDirection: "column",
        paddingTop: "10vh", // Adjust this value to control how far from the top it should be
      }}
    >
      <img src={logo} alt="Logo" style={{ height: "300px" }} />
      <div
        className="dashboard-container"
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <LoginPage />
      </div>
    </div>
  );
};

export default Landing;
